import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MedDirectiveSharedModule, MedNotificationContainerModule } from "@mk/med-ui";

import { MedNotificationComponent } from "./med-notification.component";
import { MedNotificationItemComponent } from "./med-notification-item/med-notification-item.component";
import { MedNotificationService } from "./med-notification.service";

@NgModule({
  declarations: [
    MedNotificationComponent,
    MedNotificationItemComponent,
  ],
  imports: [
    CommonModule,
    MedDirectiveSharedModule,
    MedNotificationContainerModule,
  ],
  exports: [
    MedNotificationComponent,
    MedDirectiveSharedModule,
    MedNotificationItemComponent,
  ],
  providers: [
    MedNotificationService,
  ],
})
export class MedNotificationModule { }
